import React from 'react';
import { browserHistory } from 'react-router';
import Card from '../../../core/layout/Card';
import Button from '../../../core/form/Button';
import Breadcrumb from '../../../core/layout/Breadcrumb';
import PlacementTestListContainer from './PlacementTestListContainer';
import PlacementTestListFilterContainer from './PlacementTestListFilterContainer';
import { Roles } from '../../../core/util';
import Tabs from '../../../core/layout/Tabs';

const PlacementTestListScene = (props) => (
  <div>
    <Breadcrumb
      crumbs={[
        {
          text: 'Placement Test',
        },
      ]}
    />
    <Tabs
      storeInUrl
      tabs={[
        ...([Roles.ADMIN, Roles.CONTENT_ADMIN].includes(localStorage.role) ? [{ id: 'default', name: 'Default' }] : []),
        ...props.rulers,
      ].map((d) => ({
        key: d.id,
        title: d.name,
        content: (
          <Card
            key={d.id}
            title={`${d.name} - Placement Test`}
            actions={
              <Button
                type="primary"
                label="New Grammar"
                icon="plus"
                onClick={() => browserHistory.push(`/placement-test/ruler/${d.id}/new`)}
              />
            }
          >
            <PlacementTestListFilterContainer />
            <PlacementTestListContainer rulerId={d.id} />
          </Card>
        ),
      }))}
    />
  </div>
);

export default PlacementTestListScene;
